import React, { useEffect } from 'react';
import  './Index.css'
import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="main bg-" >
    <Card className="text-center contact-card mt-5 m-4" style={{ backgroundColor: 'lightgrey'}}> 
      <Card.Body>
        <Card.Title><h1>Contact <hr /></h1></Card.Title>
        <Row xs={1} md={2} lg={4} className="g-3">
          <Col>
            <div className="contact-info">
              <h2><i className="fa-solid fa-phone fs-4"></i> Mobile</h2>
              <h5>+91 8096858075</h5>
            </div>
          </Col>
          <Col>
            <div className="contact-info">
              <h2><i className="fa-solid fa-envelope"></i> Email</h2>
              <h5>naveenkumarare66@gmail.com</h5>
            </div>
          </Col>
          <Col>
            <div className="contact-info">
              <h2><i class="fa-brands fa-whatsapp" style={{ color: 'var(--bs-success)' }}></i> WhatsApp</h2>
              <h5><a className='btn btn-outline-success rounded' href="https://wa.me/918096858075" target="_blank" rel="noopener noreferrer">Message</a></h5>
            </div>
          </Col>
          <Col>
            <div className="contact-info">
              <h2><i className="fa-brands fa-linkedin"style={{ color: 'var(--bs-primary)' }}></i> LinkedIn</h2>
              <h5><a className='btn btn-outline-primary ' href="https://www.linkedin.com/in/arenaveenkumar/" target="_blank" rel="noopener noreferrer">Connect</a></h5>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>

    


    </div>
  );
}
